import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "popTerms",
  props: {
    show: null
  },
  computed: {
    ...walletVuex.mapState(["isMobile"])
  },
  methods: {
    onClose() {
      this.$parent.form.check = false;
      this.$parent.onCheck();
      this.$emit("update:show", false);
    },
    onSkip() {
      this.onClose();
      setTimeout(() => {
        this.$router.push("/launch");
      }, 200);
    },
    onCopy() {
      this.$copyText("support@monpop.fun").then(e => {
        this.$toasted.clear();
        this.$toasted.success("Copied!");
      }, function (e) {
        console.log("222255", e);
      });
    }
  }
};